import { FIGMA_EMBED_ROUTE_PREFIX } from '@/consts/auth.consts';

export const generateRandomString = (length: number): string => {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
  const charactersLength = characters.length;
  const randomValues = new Uint8Array(length);
  crypto.getRandomValues(randomValues);

  let result = '';
  for (let i = 0; i < length; i++) {
    result += characters.charAt(randomValues[i] % charactersLength);
  }

  return result;
};

export const sha256 = async (string: string): Promise<string> => {
  const utf8 = new TextEncoder().encode(string);
  const hashBuffer = await crypto.subtle.digest('SHA-256', utf8);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map((bytes) => bytes.toString(16).padStart(2, '0')).join('');
  return hashHex;
};

export const isInsideIframe = (): boolean => {
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
};

export const isFigmaEmbedRoute = (): boolean => {
  return window.location.pathname.startsWith(FIGMA_EMBED_ROUTE_PREFIX);
};

// We're embedded in Figma when we're on the embed route and inside a frame.
// This reads only the browser, so it works even where the embed-mode context
// provider isn't mounted (for example the global crash screen).
export const isFigmaEmbedContext = (): boolean => {
  return isFigmaEmbedRoute() && isInsideIframe();
};

export const isCommunityPreviewOptionalAuth = (): boolean => {
  const pathname = window.location.pathname;
  return (
    (pathname.startsWith('/embed/community/flow/') || pathname.startsWith('/embed/community/tool/')) &&
    new URLSearchParams(window.location.search).get('auth') === 'optional'
  );
};
